<template>
  <v-data-table
    v-model="selected"
    :headers="headers"
    :items="desserts"
    :single-select="singleSelect"
    item-key="id"
    show-select
    :items-per-page="10"
    :footer-props="{
      'items-per-page-options': [10, 25],
    }"
    style="padding: 25px"
  >
    <template v-slot:top>
      <div>
        <v-toolbar style="box-shadow: none !important">
          <v-toolbar-title>
            <b>{{ title }}</b>
          </v-toolbar-title>
        </v-toolbar>

        <div style="padding: 15px 25px 10px 27px">
          <v-layout row>
            <v-flex md8>
              <!-- <v-btn
                  color="primary"
                  v-on:click="send()"
                  style="margin: 0px 10px"
                  depressed
                  small
                >
                  Send to Approver
                </v-btn> -->

              <v-btn class="ml-1" small depressed v-on:click="formSearch">
                Filter
              </v-btn>

              <v-btn class="ml-1" small depressed v-on:click="refreshAll">
                Refresh
              </v-btn>

              <v-btn
                :disabled="selected.length < 1"
                class="ml-1"
                color="info"
                small
                depressed
                v-on:click="cataloguingProcess()"
              >
                Add to Cataloguing
              </v-btn>
            </v-flex>

            <v-flex md4>
              <v-text-field
                label=""
                v-model="val"
                placeholder="Enter Your Keywords"
                solo
                v-on:keyup.enter="getMaterial()"
                append-icon="search"
                @click:append="getMaterial()"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </div>
      </div>

      <v-dialog v-model="loading" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Loading Data..
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="form_search" max-width="500px">
        <v-card>
          <v-card-title> Filter List </v-card-title>
          <v-card-text>
            <div style="padding: 10px">
              <label> Status </label>
              <v-select
                item-text="STATUS_NAME"
                item-value="STATUS_ID"
                v-model="filter_status"
                :items="list_status"
                label="Choose Status"
                solo
              ></v-select>

              <div>
                <label>Start Date</label>
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="date"
                      label="Choose Date"
                      append-icon="event"
                      readonly
                      solo
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="date" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false"
                      >Cancel</v-btn
                    >
                    <v-btn text color="primary" @click="$refs.menu.save(date)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-menu>
              </div>

              <div>
                <label>End Date</label>
                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  :close-on-content-click="false"
                  :return-value.sync="date2"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="date2"
                      label="Choose Date"
                      append-icon="event"
                      readonly
                      solo
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="date2" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu2 = false"
                      >Cancel</v-btn
                    >
                    <v-btn text color="primary" @click="$refs.menu2.save(date2)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-menu>
              </div>
            </div>
            <div align="right">
              <v-btn
                rounded
                depressed
                class="mr-2"
                @click="form_search = false"
              >
                Close
              </v-btn>

              <v-btn
                color="primary"
                rounded
                depressed
                :loading="loading"
                v-on:click="getMaterial()"
              >
                Search
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog
        v-if="dialogDetailMaterial"
        v-model="dialogDetailMaterial"
        max-width="80%"
        scrollable
      >
        <detail-material
          :data="detail_data"
          @closeDialog="dialogDetailMaterial = false"
        ></detail-material>
      </v-dialog>

      <v-dialog
        v-if="dialogFeedBack"
        v-model="dialogFeedBack"
        max-width="500"
        scrollable
      >
        <feedback
          :data="feedback_data"
          @closeDialog="dialogFeedBack = false"
        ></feedback>
      </v-dialog>

      <v-snackbar
        v-model="snackbar.open"
        :timeout="snackbar.timeout ? snackbar.timeout : 7000"
        top
      >
        {{ snackbar.message_text }}

        <template v-slot:action="{ attrs }">
          <v-btn
            :color="snackbar.button_type ? snackbar.button_type : 'primary'"
            v-bind="attrs"
            @click="snackbar.open = false"
          >
            {{ snackbar.button_text ? snackbar.button_text : "Close" }}
          </v-btn>
        </template>
      </v-snackbar>
    </template>

    <template v-slot:item.action="{ item }">
      <v-menu offset-y transition="slide-y-transition">
        <template v-slot:activator="{ on }">
          <v-btn text v-on="on" :disabled="selected.length > 1">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-list>
            <v-list-item-group>
              <v-list-item v-on:click="openModalDetail(item)">
                <v-list-item-title>
                  <v-icon color="primary" class="menu-icon"
                    >mdi-file-document</v-icon
                  >
                  Detail
                </v-list-item-title>
              </v-list-item>

              <v-list-item v-on:click="cataloguingProcess(item)">
                <v-list-item-title>
                  <v-icon color="#03a9f4" class="menu-icon"
                    >mdi-file-cabinet</v-icon
                  >
                  Add to Cataloguing
                </v-list-item-title>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-menu>
    </template>

    <template v-slot:item.status="{ item }">
      <status
        :status="item.status"
        :image_available="item.image_available"
        @eventDetail="openModalDetail(item)"
      ></status>
    </template>

    <template v-slot:item.type_input="{ item }">
      <status :status="item.type_input"></status>
    </template>

    <template v-slot:item.part_number="{ item }">
      <td
        :style="{
          'background-color':
            item.possibility_duplicate === 'MEDIUM'
              ? '#FFB74D'
              : item.possibility_duplicate === 'HIGH'
              ? '#EF9A9A'
              : '',
        }"
        class="pa-5"
      >
        {{ item.part_number }}
      </td>
    </template>

    <template v-slot:item.manufacturer="{ item }">
      <td
        :style="
          item.possibility_duplicate === 'HIGH'
            ? 'background-color: #EF9A9A'
            : ''
        "
        class="pa-5"
      >
        {{ item.manufacturer }}
      </td>
    </template>

    <template v-slot:item.possibility_duplicate="{ item }">
      <status :status="item.possibility_duplicate"></status>
    </template>

    <template v-slot:item.basic_data_text="{ item }">
      <BasicDataText :data="item.basic_data_text"></BasicDataText>
    </template>
  </v-data-table>
</template>

<script>
import DetailMaterialVue from "../component/DetailMaterial.vue"
import FeedBackVue from "../component/FeedBack.vue"
import StatusVue from "../component/Status.vue"
import BasicDataText from "../component/BasicDataText.vue"

export default {
  components: {
    "detail-material": DetailMaterialVue,
    feedback: FeedBackVue,
    status: StatusVue,
    BasicDataText,
  },
  data() {
    return {
      name: "Cataloguing",
      title: "Cataloguing Queue",
      storage: {
        session: true,
      },
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      singleSelect: false,
      selected: [],
      loading: false,
      loadingTable: true,
      val: "",
      log: "",
      tab: "tab-1",
      tab2: "tab-1",
      headers: [
        {
          text: "Action",
          value: "action",
          sortable: false,
          width: 50,
          align: "center",
        },
        { text: "Status", value: "status", width: "180" },
        { text: "Description", value: "description", width: "300" },
        { text: "Request Number", value: "request_no", width: "150" },
        { text: "Request Type", value: "type_input", width: "130" },
        { text: "Requester", value: "request_by", width: "150" },
        { text: "Material Number", value: "material_number", width: "160" },
        { text: "Request Date", value: "request_date", width: "160" },
        { text: "INC Code", value: "inc_code", width: "130" },
        { text: "Item Name", value: "inc_name", width: "250" },
        { text: "Basic Data Text", value: "basic_data_text", width: "400" },
        { text: "Manufacturer", value: "manufacturer", width: "150" },
        { text: "Part Number", value: "part_number", width: "150" },
        { text: "Plant", value: "plant_name", width: "150" },
        { text: "Base Unit", value: "base_unit", width: "150" },
        { text: "Remarks", value: "remarks", width: "200" },
        // {
        //   text: "Possibility Duplicate",
        //   value: "possibility_duplicate",
        //   width: "170",
        // },
      ],
      desserts: [],
      list_message: [],
      list_message2: [],
      user_id: "",
      email_approval: "noreply@sinarmas.com",
      user_request: "",
      departement_id: "",
      username: "",
      user_approval: "",
      request_no: "",
      message: "",
      requester_message: "",
      requester_date: "",
      modal_message: "",
      modal_detail: false,
      detail: [],
      form_search: false,
      menu: false,
      menu2: false,
      user_cataloguer: "",
      list_approval_user: [],

      //Dropdown......................................
      list_status: [
        { STATUS_ID: "CAT", STATUS_NAME: "Waiting Cataloguing" },
        { STATUS_ID: "DRAFT_CAT", STATUS_NAME: "Waiting Send to SAP" },
        { STATUS_ID: "REG", STATUS_NAME: "Registered On SAP" },
        { STATUS_ID: "FAIL", STATUS_NAME: "Failed" },
      ],

      //storage.....................................
      storage_user_id: atob(localStorage.getItem("user_id")),
      storage_username: atob(localStorage.getItem("username")),
      storage_fullname: atob(localStorage.getItem("fullname")),
      storage_company_id: atob(localStorage.getItem("company_id")),
      storage_company_name: atob(localStorage.getItem("company_name")),
      storage_role: atob(localStorage.getItem("role")),
      storage_departement_id: atob(localStorage.getItem("departement_id")),
      storage_server: atob(localStorage.getItem("server")),

      dialogDetailMaterial: false,
      dialogFeedBack: false,
      detail_data: null,
      feedback_data: null,

      snackbar: {
        open: false,
        message_text: null,
        button_type: "primary",
        button_text: "Close",
        timeout: 3000,
      },
    }
  },
  mounted() {
    this.getMaterial()
    if (this.storage_role != "CAT") {
      this.$router.push("/login")
    }
  },
  methods: {
    getMaterial() {
      var self = this
      var val = self.val
      var url = self.base_url + "material/getdata/cataloguing"
      this.loading = true

      this.axios
        .post(url, {
          param: val,
          user_id: self.storage_user_id,
          filter_status: self.filter_status,
          filter_startdate: self.date,
          filter_enddate: self.date2,
        })
        .then(function(response) {
          self.desserts = response.data
          self.form_search = false
          self.loadingTable = false
          self.selected = []
        })
        .finally(() => {
          this.loading = false
        })
    },
    openModalDetail(item) {
      this.detail_data = item
      this.dialogDetailMaterial = true
    },
    openDialogFeedback(item) {
      this.dialogFeedBack = true
      this.feedback_data = item
    },
    cataloguingProcess(item = null) {
      const id = this.selected.length > 0 ? this.selectedRows() : item.id

      this.$dialog.confirm({
        text: "Are you sure you want to process this item ?",
        title: "Cataloguing Process",
        overlay: true,
        actions: {
          false: "No",
          true: {
            color: "primary",
            text: "Yes",
            handle: () => {
              var self = this
              var url = self.base_url + "material/process/add_cataloguing"
              this.axios
                .post(url, {
                  id: id,
                  user_id: self.storage_user_id,
                })
                .then(function(response) {
                  if (response.status === 200) {
                    self.snackbar = {
                      open: true,
                      message_text: "Add to cataloguing success",
                      button_type: "primary",
                      button_text: "Ok",
                    }

                    self.getMaterial()
                  }
                })
            },
          },
        },
      })
    },
    formSearch() {
      this.form_search = true
    },
    edit(item) {
      var id = item.id
      var server = "GEMS"

      setTimeout(() => {
        this.$router.push({
          path: "/addRegister/" + btoa(server) + "/edit/" + btoa(id),
        })
      }, 500)
    },
    refreshAll() {
      this.val = ""
      this.filter_status = ""
      this.filter_server = ""
      this.date = ""
      this.date2 = ""
      this.getMaterial()
    },
    checkRows() {
      var total = this.selected.length
      var a = 0
      for (var i = 0; i < total; i++) {
        if (
          this.selected[i].status != "REG" &&
          this.selected[i].status != "RJT"
        ) {
          a++
        }
      }
      return a
    },
    selectedRows() {
      var arritem = this.selected
      var item = ""

      if (arritem.length > 0) {
        for (var a = 0; a < arritem.length; a++) {
          item += "," + arritem[a].id
        }
        item = item.substring(1)
      }
      return item
    },
  },
}
</script>

<style>
.menu-icon {
  margin-top: -3px;
  margin-right: 10px;
}
</style>
